// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".space-bottom[data-v-20bb3d05]{margin-bottom:7rem}", "",{"version":3,"sources":["webpack://./resources/client/forms/CallScriptStepForm.vue"],"names":[],"mappings":"AACA,+BACE,kBAAF","sourcesContent":["\n.space-bottom {\n  margin-bottom: 7rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
